import React from "react";
import LegalPage from "@/pages/legal/LegalPage";

const Terms = () => (
  <LegalPage testid="page-terms" overline="Legal" title="Terms & Conditions" lastUpdated="December 2025">
    <h2>Acceptance of Terms</h2>
    <p>
      By accessing or using the website of The Exit Strategy Society ("ESS"), a DBA of 4ever
      Wellness LLC, you agree to be bound by these Terms & Conditions. If you do not agree,
      please discontinue use of the website.
    </p>

    <h2>Educational Purpose</h2>
    <p>
      All content, coaching, courses, products, and resources offered by ESS are provided for
      educational and informational purposes only. They are not a substitute for legal, tax,
      accounting, investment, financial advisory, medical, mental health, or therapeutic
      services.
    </p>

    <h2>Purchases</h2>
    <p>
      Digital product purchases are processed through trusted third-party payment providers.
      Pricing, descriptions, and access terms are as displayed at the time of purchase. All
      sales are final unless otherwise stated.
    </p>

    <h2>Intellectual Property</h2>
    <p>
      All content — including but not limited to text, graphics, logos, frameworks, and
      proprietary methodologies such as the Digital Burnout Cycle™, Digital Clarity Method™,
      and RESET Framework™ — is the property of ESS and 4ever Wellness LLC.
    </p>

    <h2>Limitation of Liability</h2>
    <p>
      ESS will not be liable for any indirect, incidental, or consequential damages arising
      from your use of the website or our services. Individual results may vary.
    </p>

    <h2>Governing Law</h2>
    <p>These Terms are governed by the laws of the United States.</p>
  </LegalPage>
);

export default Terms;
